export const PLACEHOLDER_SIZE = {
    width: 400,
    height: 39,
};
